document.addEventListener('DOMContentLoaded', () => {
  
  const SRC_ID = 'shopify-section-template--20206837170411__section_slideshow_responsive_QGC4fP';
  const DEST_ID = 'shopify-section-template--20206837170411__section_html_qyVNjx';

  const srcSection = document.getElementById(SRC_ID);
  const destSection = document.getElementById(DEST_ID);
  if (!srcSection || !destSection) return;

  const OFFSET = 0;

  srcSection.addEventListener('click', (e) => {
    const trigger = e.target.closest('a.link-over-image, .homepage-slideshow');
    if (!trigger || !srcSection.contains(trigger)) return;

    e.preventDefault();

    const y = destSection.getBoundingClientRect().top + window.pageYOffset - OFFSET;

    window.scrollTo({ top: y, behavior: 'smooth' });
  });
});
